import React from 'react';

interface EmptyStateProps {
  message: string;
  subMessage?: string;
  icon?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message, subMessage, icon }) => {
  return (
    <div className="text-center py-12 px-4 text-gray-500 flex flex-col items-center">
      {icon && <div className="mb-4">{icon}</div>}
      <h3 className="text-lg font-medium mb-2">{message}</h3>
      {subMessage && <p className="text-sm text-gray-400">{subMessage}</p>}
    </div>
  );
};
